module.exports = __webpack_public_path__ + "static/img/soy-sauce.24d604d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/soy-sauce.svg
// module id = YNdu
// module chunks = 1